export const LOGIN_TITLE = 'Priority Based Budgeting';
export const EMAIL_SUPPORT_TEXT = 'Enter a valid email address.';
export const LOGIN_ERROR_MESSAGE = 'We could not start sign-in. Please try again.';
